import { render, staticRenderFns } from "./ContractualDocumentForm.vue?vue&type=template&id=05ffc9d2&"
import script from "./ContractualDocumentForm.vue?vue&type=script&lang=js&"
export * from "./ContractualDocumentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports